import { createFileRoute, Outlet } from '@tanstack/react-router';

// No role gate: the connector catalog is open to every authenticated user so they can
// find a system and add their own credentials. Connection configuration is redacted
// server-side for callers without a data-connectors role, and every write on this page
// is gated by useUserPermissions. See docs/features/data_connectors.md.
export const Route = createFileRoute('/_protected/t/$tenantId/connectors')({
  component: () => <Outlet />,
});
